import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=36c771fe&scoped=true&"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=36c771fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c771fe",
  null
  
)

export default component.exports